<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		</div>
		<div class="mb-2 mt-2 pt-3">
			<button-search :isphone="layout.is_phone" ref="buttonSearch" placeholder="搜索 外箱条形码" @search="searchEvent" :showGj="true">
				<!-- 左边 -->
				<template #left>
					<!-- <el-tag >总充值：{{total_list.total}}</el-tag> -->
					<!-- <el-button class="mr-2"  @click="openModel(false,1)" type="primary" size="mini" 
					v-auth="'add'+auth_val">入库</el-button> -->
					<!-- <el-button type="warning" v-auth="'add'+auth_val" @click="openModel(2)" size="mini">出库</el-button> -->

				</template>

				<!-- 高级搜索 1-->
				<template #from>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item label="入库编号" class="mb-0">
							<el-input size="small" v-model="from.number" placeholder="搜索入库编号"></el-input>
						</el-form-item>
						<el-form-item label="外箱条形码" class="mb-0">
							<el-input size="small" v-model="from.name" placeholder="搜索外箱条形码"></el-input>
						</el-form-item>
						
						
						
						
						<el-form-item label="交货方式" class="mb-0">
							<el-select v-model="from.order_type" size="small" placeholder="请选择查看类型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="自寄海外仓" :value="1"></el-option>
								<el-option label="自寄中转仓" :value="2"></el-option>
							</el-select>
						</el-form-item>
					
						
						<el-form-item label="状态" class="mb-0">
							<el-select v-model="from.status" size="small" placeholder="请选择查看类型">
								<el-option label="全部" :value="-1"></el-option>
								<el-option label="入库海外仓" :value="1"></el-option>
								<el-option label="中转已入库,待发海外	" :value="2"></el-option>
								<el-option label="待入库" :value="3"></el-option>
								<el-option label="中转发往海外中" :value="4"></el-option>
							</el-select>
						</el-form-item>
						
					


						<el-form-item label="时间" size="small" class="mb-0">
							<el-date-picker v-model="from.time" type="daterange" align="right" unlink-panels value-format="yyyy-MM-dd"
							 range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions">
							</el-date-picker>
						</el-form-item>

						

						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">搜索 </el-button>
							<el-button size="small" @click="clearSearch">清空筛选条件</el-button>
						</el-form-item>

					</el-form>
				</template>
			</button-search>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2">
			<el-table :data="tableData" @sort-change="sortChange" border style="width: 100%" @selection-change="handleSelectionChange"
			ref="table"
			 row-key="id"
			:tree-props="{children: 'children', hasChildren: true}"
			>
				<!-- <el-table-column type="selection" width="45" align="center">

				</el-table-column> -->
				<el-table-column fixed align="center" type="index" label="排序" width="50">
				</el-table-column>
				
				
				<!-- <el-table-column align="center" width="60" prop="id" label="ID">
				</el-table-column> -->
			
				
			
		
				<el-table-column align="center" width="200" prop="fir_order_no" label="入库编号">
				</el-table-column>
				
				<el-table-column align="center" width="220" prop="order_no" label="外箱条形码">
				</el-table-column>
				
				<el-table-column align="center" prop="sp_name" width="150" label="对应商户">
					<template slot-scope="v">
						<span>{{v.row.shop_name}}(<span class="text-danger">{{v.row.username}}</span>)</span>
						
					</template>
				</el-table-column>
				
				
			
			
				<el-table-column align="center" width="100"  prop="num"  label="交货方式">
					<template slot-scope="v">
						<span v-if="v.row.order_type==1" >自寄海外仓</span>
						<span v-if="v.row.order_type==2" >自寄中转仓</span>
						
						
					</template>
				</el-table-column>
			
				<el-table-column align="center" width="100"  prop="num"  label="运输方式">
					<template slot-scope="v">
						<span v-if="v.row.transport_type==1">快递</span>
						<span v-if="v.row.transport_type==2">空运</span>
						<span v-if="v.row.transport_type==3">海运</span>
						<span v-if="v.row.transport_type==4">其他</span>
						
						
					</template>
				</el-table-column>
				
				<el-table-column align="center" width="120"  prop="num"  label="报关方式">
					<template slot-scope="v">
						<span v-if="v.row.declare_type==1">单独退税报关</span>
						<span v-if="v.row.declare_type==2">不退税报关</span>
					</template>
				</el-table-column>
				
				<el-table-column align="center" width="120"  prop="num"  label="柜型">
					<template slot-scope="v">
						<span v-if="v.row.container_type==0">-</span>
						<span v-if="v.row.container_type==1">45HQ</span>
						<span v-if="v.row.container_type==2">40GP</span>
						<span v-if="v.row.container_type==3">40HQ</span>
						<span v-if="v.row.container_type==4">20GP</span>
					</template>
				</el-table-column>
				
				
				
				
				
				<el-table-column align="center" width="160"  prop="num"  label="状态">
					<template slot-scope="v">
						
						
						
						<span style="color: #888;" v-if="v.row.status==0">待确认</span>
						<span class="text-warning" v-if="v.row.status==3 && v.row.order_type==1 ">待入库海外仓</span>
						<span class="text-warning" v-if="v.row.status==3 && v.row.order_type==2 ">待入库中转仓</span>
						<span style="color: #409EFF;" v-if="v.row.status==2 ">中转已入库,待发海外</span>
						<span class="text-success" v-if="v.row.status==1 ">已入库海外仓</span>
						<span class="text-warning" v-if="v.row.status==4 ">中转发往海外中</span>
						
					</template>
				</el-table-column>
				
			
				<el-table-column align="center" width="120" prop="pro_name"  label="商品名称"></el-table-column>
				<el-table-column align="center" prop="sku" width="150"  label="商品SKU"></el-table-column>
				
				<el-table-column align="center" prop="num"  label="数量">
			
				</el-table-column>
				
				<el-table-column align="center" prop="weight"  label="重量"></el-table-column>
				
				
				<el-table-column width="140" align="center" prop="start_name"  label="中转仓库"></el-table-column>
				
				<el-table-column width="140" align="center" prop="end_name"  label="目的仓库"></el-table-column>
				
				
				
			
				
	
			
		
				<!-- 
				<el-table-column align="center" sortable="custom" prop="status"  label="状态">
					<template slot-scope="scope">
						<el-button :type="scope.row.status ? 'success' : 'danger'" size="mini" @click="changeStatus(scope.row)" plain>{{scope.row.status ? '启用' : '禁用'}}
						</el-button>
					</template>
				</el-table-column>
			 -->
		
			
				
	
			
				
				
	
				
		
				
				
				
				
				<el-table-column align="center" prop="create_time" width="200" label="下单时间">
					
				</el-table-column>
				
			
				
				

<el-table-column prop="id" :fixed="this.layout.is_phone?false:'right'" align="center" width="160" label="操作">
					<template slot-scope="scope">
						<el-button-group>
							
							
							
							<el-button v-if="(scope.row.status==3 && layout.user.ins_type==2) || (((scope.row.status==3 && scope.row.order_type==1) || scope.row.status==4) && layout.user.ins_type==1)" v-auth="'edit'+auth_val" size="mini" plain type="primary" @click="openModel(scope.row,1)">入库</el-button>
							
							<el-button v-if="scope.row.status==2 && layout.user.ins_type==2" v-auth="'edit'+auth_val" size="mini" plain type="primary" @click="openModel(scope.row,2)">出库</el-button>
							
							
							<!-- <el-button v-if="scope.row.status==1"  v-auth="'print'+auth_val" size="mini" plain type="info" @click="openPrintModel(scope.row)">打印</el-button> -->
							
						<!-- <el-button v-if="scope.row.status==2" @click="submitStatus(scope.row)"   size="mini" plain type="success">重新提交</el-button> -->

						</el-button-group>
					</template>
				</el-table-column>


				
			</el-table>
		</div>


		<div style="height: 60px;"></div>
		<el-footer class="d-flex border-top bg-white align-items-center px-0 position-fixed all_foot_page" >
			<!-- 底部 -->

			<div style="flex: 1;" class="px-2">
				<el-pagination :current-page="page.current" :page-sizes="page.sizes" :page-size="page.size" @size-change="handleSizeChange"
				 @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="page.total">
				</el-pagination>
			</div>
			<div class="scrollbar" :style="{ width: scrollbarWidth }" v-show="!layout.is_phone && showScrollbar" ref="scrollbar">
			  <div class="thumb" ref="thumb" @mousedown="onMouseDown"></div>
			</div>
		</el-footer>



		<el-dialog :title="form.edit_type==1?'入库':'出库'" :visible.sync="createModel" 
		top="5vh" :width="layout.is_phone?'90%':'50%'">
			<!-- 表单内容 -->
			<el-form :rules="rules" ref="formEdit" :model="form" :label-width="layout.is_phone?'80px':'100px'" :label-position="layout.is_phone?'top':'left'">
				
				<el-form-item label="外箱条形码" prop="remark">
					{{form.order_no}}
				</el-form-item>
			
				
				<el-row>
					<el-col :span="12">
						<el-form-item label="交货方式">
							<span v-if="form.order_type==1">自寄海外仓</span>
							<span v-if="form.order_type==2">自寄中转仓</span>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="运输方式">
							<span v-if="form.transport_type==1">快递</span>
							<span v-if="form.transport_type==2">空运</span>
							<span v-if="form.transport_type==3">海运</span>
							<span v-if="form.transport_type==4">其他</span>
						</el-form-item>
					</el-col>
					<el-col :span="12" v-if="form.transport_type!=1">
						<el-form-item label="报关方式" >
							<span v-if="form.declare_type==1">单独退税报关</span>
							<span v-if="form.declare_type==2">不退税报关</span>
						</el-form-item>
					</el-col>
					
					<el-col :span="12" v-if="form.transport_type==3">
						<el-form-item label="柜型" >
							<span v-if="form.container_type==0">-</span>
							<span v-if="form.container_type==1">45HQ</span>
							<span v-if="form.container_type==2">40GP</span>
							<span v-if="form.container_type==3">40HQ</span>
							<span v-if="form.container_type==4">20GP</span>
						</el-form-item>
					</el-col>
				</el-row>
				
				<el-tag type="success" class="mb-2">商品：</el-tag>
				<div class="ml-4">
					<div class="my-2" v-for="(item,index) in form.log" :key="index">
						<div class="mb-3" style="display: flex;align-items: center;">
							<el-image v-if="item.head" style="width: 40px; height: 40px" :src="item.head" :preview-src-list="[item.head]"></el-image>
							<div class="ml-3">
								{{item.name}}({{item.sku}}) * {{item.num}} [ {{item.weight}} KG ]
							</div>
						</div>
						
						<el-row v-if="form.edit_type==1">
							<el-col :span="layout.user.ins_type==1 && form.transport_type==2?8:12">
								<el-form-item  :label="form.edit_type==1?'核对数量':'出库数量'" prop="num">
									<el-input type="number" v-model="item.num_sub" 
									:placeholder="form.edit_type==1?'核对数量':'出库数量'"  @input="checkMoney"
									clearable size="small" style="width: 93%;">
									</el-input>
								</el-form-item>
							</el-col>
							<el-col :span="layout.user.ins_type==1 && form.transport_type==2?8:12">
								<el-form-item  label="核对重量" prop="weight">
									<el-input type="number" v-model="item.weight_sub" 
									placeholder="核对重量"  @input="checkMoney"
									clearable size="small" style="width: 93%;">
									</el-input>
								</el-form-item>
							</el-col>
							
							<el-col v-if="layout.user.ins_type==1 && form.order_type==2 && form.transport_type==2" :span="8">
								<el-form-item  label="卸货费用" prop="">
									{{item.money}}
								</el-form-item>
							</el-col>
							
						</el-row>
					</div>
					
				</div>
	
				
				

				
				
				
				
				
				<el-form-item label="入库卸货费" v-if="layout.user.ins_type==1 && form.order_type==2 && form.transport_type==2">
					{{form.money}}
				</el-form-item>
				
				<el-row v-if="layout.user.ins_type==1 && form.transport_type==3 && form.is_jie==0">
					<el-col :span="12">
						<el-form-item label="入库柜数">
							<el-input type="number" v-model="form.t_num"
							placeholder="入库柜数"  @input="checkMoney"
							clearable size="small" style="width: 93%;">
							</el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="入库卸货费">
							<el-input type="number" v-model="form.total"
							placeholder="入库卸货费"  @input="checkMoney"
							clearable size="small" style="width: 93%;">
							</el-input>
						</el-form-item>
					</el-col>
				</el-row>
				
				
				
				
				<el-form-item  v-if="form.edit_type==1" label="入库拍照" prop="file">
					<el-upload
					name="file"
					  class="avatar-uploader"
					  action="/admin/image/uploadNew"
					  :headers="{token:$store.state.user.token}"
					  :data="{type:'InsFIrstZZ'}"
					  :show-file-list="false"
					  capture="camera"
					  :on-success="handleAvatarSuccess"
					  :before-upload="beforeAvatarUpload">
					  <img v-if="form.img" :src="form.img" class="avatar">
					  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
				
				
				<el-form-item v-if="form.edit_type==2" label="转单号" prop="transfer_number">
					<el-input type="text" v-model="form.transfer_number" 
					placeholder="转单号" 
					clearable size="small" style="width: 93%;">
					</el-input>
				</el-form-item>
				
				
				
				
				
				
				
				
				
				
				
				
				
				
			
				
			
			
				
				
				
	
				

				
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">取 消</el-button>
				<el-button :loading="layout.loading" type="primary" @click="submit">确 定</el-button>
			</div>
		</el-dialog>
		
		
		
		
	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				rules: {

					num: [{
							required: true,
							message: "请输入核对数量",
							trigger: 'blur',
						},
					],
					weight: [{
							required: true,
							message: "请输入核对重量",
							trigger: 'blur',
						},
					],
					transfer_number: [{
							required: true,
							message: "请输入转单号",
							trigger: 'blur',
						},
					],
					
					
				},
				rulesprint:{
					
				},
				printModel: false,
				createModel: false,
				editIndex: -1,
				//搜索数据
				from: {
					name: '',
					number:'',
					status:-1,
					order_type:-1,
					time: [],
				},
				model_title: 'First',
				auth_val: 'First',
				preUrl: "user/firstList", //列表地址
				addUrl: "user/addFirst", //添加/修改地址
				editStatusUrl: "user/editStatusFirst", //修改状态地址
				tableData: [],
				form: {
					id: 0,
					edit_type:1,
					img:'',
					head:'',
					num:'',
					weight:'',
					order_no:'',
					pro_name:'',
					sku:'',
					transfer_number:'',
					type:1,
				},
				printData:{
					id:0,
					size:1,
					is_pro:1
				},
				logItem:{
					pid:'',
					box:1,
					num:'',
				},
				prop: 'create_time',
				sort: 'descending',
				slist: [],
				plist: [],
				total_list: [],
				check_img_list: [],
				fileList: [],
				now_num:0,
				godown_1:[],
				godown_2:[],
				product:[],
				sys:[],
			}
		},
		watch: {
			activeName(e) {
				console.log(e);
			}
		},
		created() {
			this.commonList('firstData');
			
		},
		methods: {
			
			checkMoney() {
				if(this.layout.user.ins_type==1){
					if(this.form.order_type==2 && this.form.transport_type != 1){
						if(this.form.transport_type==2){
							//空运
							this.form.money = 0;
							
							for(let i = 0;i<this.form.log.length;i++){
								let money = 0
								if(this.form.log[i].is_min==1){
									money = (this.form.log[i].weight_sub * parseFloat(this.sys.first_air_min))
								}else{
									money = (this.form.log[i].weight_sub * parseFloat(this.sys.first_air_pu))
								}
								this.form.money += parseFloat(money)
								this.form.log[i].money = money.toFixed(2)
								
							}
							this.form.money = this.form.money.toFixed(2)
							
						}
						
						if(this.form.transport_type==3){
							//海运
							let g_money  = this.sys['first_sea_'+this.form.container_type]
							this.form.total = (this.form.t_num * g_money).toFixed(2)
						}
					}
				}
				
				
		
			},
			
		
		
		//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					
					let list = all.data.list
				
					this.sys = list.sys
					
					this.layout.loading = false;
				}).catch(err => {
					// 失败
					this.layout.loading = false;
				})
			},
			 
			handleClick(tab, event) {
				this.search = ''
				this.clearSearch()
				this.getList()
			},
			sortChange(column) {

				this.prop = column.prop
				this.sort = column.order
				this.getList()
			},
			//提交
			submit() {
				
				this.$refs.formEdit.validate(res => {
					if (res) {
						let url = '/admin/user/addFirst'
						if(this.form.edit_type==2){
							url = '/admin/user/addFirstChu'
						}
						this.layout.loading = true;
						this.axios.post(url, this.form, {
							token: true
						}).then(res => {
							let all = res.data
							if (all.code == 1) {
								this.$message({
									message: all.msg,
									type: 'success'
								});
								this.createModel = false
								this.getList()
								
							}
							
							this.layout.loading = false;
						}).catch(err => {
							this.layout.loading = false;
						})
					}
				})
			},
			
		
			handleAvatarSuccess(res, file) {
				this.form.img = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.head = res.encryption.data.list.url
				}
			  },
			
			  beforeAvatarUpload(file) {
				const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'  || file.type === 'image/gif';
				const isLt2M = file.size / 1024 / 1024 < 2;
		
				if (!isJPG) {
				  this.$message.error('文件格式错误!');
				}
				if (!isLt2M) {
				  this.$message.error('上传图片大小不能超过 2MB!');
				}
				return isJPG && isLt2M;
			  },
			  
		
		
			// 打开模态框
			openModel(e, type) {
				let log_arr = []
				
				log_arr.push({
					id:e.id,
					head:e.pro_head,
					name:e.pro_name,
					sku:e.sku,
					num:e.num,
					num_sub:e.num,
					weight:e.weight,
					weight_sub:e.weight,
					money:e.money,
					total:e.total,
					is_min:e.is_min,
				})
			
				if(e.children.length!=0){
					for(let i = 0 ;i<e.children.length;i++){
						log_arr.push({
							id:e.children[i].id,
							head:e.children[i].pro_head,
							name:e.children[i].pro_name,
							sku:e.children[i].sku,
							num:e.children[i].num,
							num_sub:e.children[i].num,
							weight:e.children[i].weight,
							weight_sub:e.children[i].weight,
							money:e.children[i].money,
							total:e.children[i].total,
							is_min:e.children[i].is_min,
						})
					}
				}
				console.log(e)
				// 修改
				this.form = {
					id: e.id,
					img:'',
					head:'',
					num:e.num,
					log:log_arr,
					order_no:e.order_no,
					pro_name:e.pro_name,
					declare_type:e.declare_type,
					transport_type:e.transport_type,
					container_type:e.container_type,
					order_type:e.order_type,
					is_min:e.is_min,
					money:e.money,
					total:e.total,
					sku:e.sku,
					is_jie:e.is_jie,
					weight:e.weight,
					t_num:1,
					transfer_number:type==1?'1':'',
					edit_type:type,
					type:1,
				}
				
				this.editIndex = e.id
				// 打开dialog
				this.createModel = true
			},

			//公共列表

			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.total_list = e.total_list
				
				this.check_img_list = e.list.map(item => {
					return item.head
				})
			},
			// 清空筛选条件
			clearSearch() {
				this.from = {
					name: '',
					number:'',
					status:-1,
					order_type:-1,
					time: [],
				}

				this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 选择图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
	.protable{
		width: 94%;
		input::-webkit-outer-spin-button,
		input::-webkit-inner-spin-button {
		    -webkit-appearance: none;
		}
		input[type="number"] {
		    -moz-appearance: textfield;
		}
		inpit {
		    border: none
		}
	}
	.protable th,.protable td{
		text-align: center;
		line-height: 40px;
	}
	.tt_w{
		width: 100px;
	}
	.tt_div{
		display: flex;
		align-items: center;
		margin-bottom: 10px;
		
		
	}
</style>
